import Vue from 'vue';
import Router from 'vue-router';
import protectedAxios from './auth/axios.js';
import axios from 'axios';
import { store } from './store.js';
import userManager from './auth/userManagerInstance.js';
import Callback from './views/Callback';
import Unauthorized from './views/Unauthorized';
import Version from './views/Version.vue';
const { isSumarRouteNormalization } = require('./utils/sumarFlow');

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/loginotp',
      name: 'loginotp',
      meta: { otpguid: true },
      component: () => import('@/views/LoginOTP'),
    },
    {
      path: '/uploadop',
      name: 'uploadop',
      meta: { otpguid: true },
      component: () => import('@/views/UploadOPOTP'),
    },
    {
      path: '/uploadoptop',
      name: 'uploadoptop',
      component: () => import('@/views/LoginOTP'),
    },
    {
      path: '/reset-password/:hash',
      name: 'reset-password',
      component: () => import('@/views/ChangeForgottenPassword'),
    },
    {
      path: '/',
      meta: { authorized: true },
      component: () => import('@/views/Index'),
      children: [
        {
          path: '/',
          name: 'dashboard',
          meta: { authorized: true },
          component: () => import('@/views/Dashboard'),
          beforeEnter: async (to, from, next) => {
            let isLoggedIn = await store.getters['auth/loggedIn'];
            let isDealer = await store.getters['auth/isDealer'];
            if (isLoggedIn && isDealer == false) {
              return next('/nove-financovanie')
            }
            next()
          }
        },    
        {
          path: '/nove-financovanie',
          name: 'noveFinancovanie',
          meta: { authorized: true, anonymous: true },
          beforeEnter: async (to, from, next) => {
              let loggedInOAuthClientZoneUser = await axios.get(window._env_config.AUTH_SERVER_URL + '/api/authenticate/isLoggedIn/client-zone', { withCredentials: true })
              .then(res => res.data?.result).catch(err => false);
            if (loggedInOAuthClientZoneUser) {

              await protectedAxios
                .get(`/login/action-redirect`, {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  params: {
                    step: -1
                  },
                })
                .then(res => {
                  if (res.data != null) {
                    window.open(res.data, '_self');
                  }
                })
            }
             return next('/obchodny-pripad')
          }
        },
        {
          path: '/logout',
          name: 'logout',
          meta: { authorized: true, anonymous: true },
          component: () => import('@/views/Logout'),
        },
        {
          path: '/fill-form/:guid',
          name: 'fill-form',
          meta: { authorized: true, anonymous: true, formguid: true },
          component: () => import('@/views/FillForm'),
          beforeEnter: (to, from, next) => {
            if (to.matched.some(record => record.meta.formguid)) {
              let formGuid = to.params.guid;
              if (formGuid) {
                store.commit('setfillCacheGuid', formGuid);
              }
              next();
            }
          },
        },
        {
          path: '/obchodne-pripady',
          name: 'obchodne-pripady',
          meta: { authorized: true },
          component: () => import('@/views/ObchodnePripady'),
        },
        {
          path: '/obchodny-pripad',
          name: 'novyPripad',
          meta: { authorized: true, anonymous: true },
          component: () => import('@/views/PripadyWizard'),
        },
        {
          path: '/obchodny-pripad/:new_id',
          name: 'editPripad',
          meta: { authorized: true, anonymous: true, authenticateIfClientObc: true },
          component: () => import('@/views/PripadyWizard'),
        },
        {
          path: '/obchodny-pripad/:new_id/sumar',
          name: 'pripadSumar',
          meta: { authorized: true, anonymous: true, authenticateIfClientObc: true },
          component: () => import('@/views/PripadyWizard'),
        },
        {
          path: '/obchodny-pripad/:new_id/sumar/najomca',
          name: 'pripadSumarNajomca',
          meta: { authorized: true, authenticateIfClientObc: true },
          component: () => import('@/views/PripadyWizard'),
        },
        {
          path: '/obchodny-pripad/:new_id/sumar/dodatInfo',
          name: 'pripadSumarDodatInfo',
          meta: { authorized: true, authenticateIfClientObc: true },
          component: () => import('@/views/PripadyWizard'),
        },
        {
          path: '/administracia',
          name: 'administracia',
          meta: { authorized: true, admin: true },
          component: () => import('@/views/Administracia'),
          beforeEnter: (to, from, next) => {
            if (to.matched.some(record => record.meta.admin)) {
              let isAdmin = store.getters['auth/user'].admin;
              if (isAdmin) {
                next();
              }
            }
          },
        },
        {
          path: '/zmena-hesla',
          name: 'zmena-hesla',
          meta: { authorized: true },
          component: () => import('@/views/ChangePassword'),
          beforeEnter: (to, from, next) => {
            let frmLogged = store.getters['auth/user'].frmLogged;
            if (frmLogged) {
              next();
            }
          },
        },
        {
          path: '/zmena-hesla-signatus',
          name: 'zmena-hesla-signatus',
          meta: { authorized: true },
          component: () => import('@/views/ChangePasswordSignatus'),
        },
        {
          path: '/tlacdokumentov',
          name: 'tlacdokumentov',
          meta: { authorized: true },
          component: () => import('@/views/TlacDokumentov'),
        },
        {
          path: '/obchodny-pripad/:new_id/najomca',
          name: 'najomca',
          meta: { authorized: true },
          component: () => import('@/views/Najomca'),
        },
        {
          path: '/dokumentyupload/:new_id/:cisloPredmetu/:poznamka',
          name: 'dokumentyupload',
          meta: { authorized: true },
          component: () => import('@/views/DokumentyUpload'),
        },
        {
          path: '/obchodny-pripad/:new_id/predmety/:cislo_predmetu/preberaci-protokol',
          name: 'preberaci-protokol',
          meta: { authorized: true },
          component: () => import('@/views/PreberaciProtokol'),
        },
        {
          path: '/techcar/',
          name: 'techcar',
          meta: { authorized: true },
          component: () => import('@/views/Techcar'),
        },
        {
          path: '/tesla',
          name: 'ext_app_token_tesla',
          meta: { authorized: true, anonymous: true },
          beforeEnter: async (to, from, next) => {            
            await handleExtAppTokenRequest('TESLA_WEB', to?.query?.token, next)
          }
        }

      ],
    },
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: Unauthorized,
    },
     {
      path: '/version',
      name: 'version',
      meta: { authorized: true },
      component: Version,
    },
  ],
});


const handleExtAppTokenRequest = async (appLogin, token, next) => {

  if (!token) {
     return next({ name: 'Unauthorized' });
  }
  else {
    const redirect = await getExtAppRedirect(appLogin, token)
    if (redirect) {
      if (redirect.startsWith('/')) {
        return next(redirect) 
       } else {
          window.location.href = redirect
          return
        }
    }

    return next({ name: 'Unauthorized' });
  }  
}

const getExtAppRedirect = async (appLogin, token) => {

  try {
    
    const res = await protectedAxios.post(
      '/v1/external/token/redirect',     
      { appLogin, token }
    );
    
    return res.data?.result?.redirectUrl;
      
    } catch (e) {
      console.error('Failed to get redirect URL', e);
      return null;
    }
}


export default router;

router.beforeResolve(async (to, from, next) => {
  let loggedInOAuthUser = await axios.get(window._env_config.AUTH_SERVER_URL + '/api/authenticate/isLoggedIn/user', { withCredentials: true })
    .then(res => res.data?.result).catch(err => false);
  let loggedInOAuthClientZoneUser = await axios.get(window._env_config.AUTH_SERVER_URL + '/api/authenticate/isLoggedIn/client-zone', { withCredentials: true })
    .then(res => res.data?.result).catch(err => false);
  let isLoggedInApp = await store.getters['auth/loggedIn'];
   
   if (!isLoggedInApp && loggedInOAuthUser == false) {
    await axios.get(window._env_config.AUTH_SERVER_URL + '/api/authenticate/anonymous-access', { withCredentials: true })
                .then(async(res) => {
                  if (res.data?.result?.token) {
                    store.commit('auth/setAnonymousUser', res.data.result.token)
                    await userManager.removeUser();
                  }
                })
  }
  next()
})

router.beforeEach(async (to, from, next) => { 
  let allowedSchvalenieRequestRoutes = [
    'editPripad',
    'pripadSumar',
    'najomca',
    'pripadSumarNajomca',
    'pripadSumarDodatInfo',
  ];
  
  if (!to.matched.some(record => allowedSchvalenieRequestRoutes.includes(record.name))) {
    store.commit('setOdoslatNaSchvalenieRequest', null);
  }
  if (isSumarRouteNormalization(to, from)) {
    next();
    return;
  }

  let isLoggedIn = await store.getters['auth/loggedIn'];
  let isAnonymous = store.getters['auth/isAnonymous']

  if (to.matched.some(record => record.meta.otpguid)) {
    let guid = to.query.id;
    if (!guid) {
      guid = store.state.otp.guid;
    }

    store.commit('setPripad', null);
    let guidOk = await store.dispatch('auth/checkOtpGuid', guid);
    if (guidOk) {
      next();
    }
  } else {

    if (isLoggedIn) {
      if (to.matched.some(record => record.meta.formguid)) {
        next();
      } else {
        try {
          const newId = await protectedAxios.get('/controls/hascache').then(res => res.data);

          if (newId && to.name != 'editPripad'){
            next({
              path: `/obchodny-pripad/${newId}`,
            });
          }else {
            next();
          }
        } catch (error) {
          return next();
        }
      }
    }
    else if (to.matched.some(record => record.meta.authenticateIfClientObc) && to.params?.new_id != null) {
      const isClientObc = await protectedAxios.get(`/pripady/${to.params.new_id}/je-klientsky`).then(res => res.data).catch(() => false)
      if(isClientObc) {
            await store.dispatch('auth/authenticate', {returnPath: to.path, customQueryParams: to.query});
            next();
      }
      else {
            next()
      }
      
   }
   else if (to?.query?.req == 'auth' ||  (to.matched.some(record => record.meta.authorized) &&  !(to.matched.some(record => record.meta.anonymous && isAnonymous))) ) {    
      await store.dispatch('auth/authenticate', {returnPath: to.path, customQueryParams: to.query});
      next();
    } else{
      next();
    }
  }
});
